import Request from '@/utils/request';

export default async ({ vars, stids, start, end }) => {
  const options = {
    params: {
      vars,
      stids,
      start,
      end,
    },
  };
  console.log(JSON.stringify(options, null, '\t'));
  const response = await Request.get('/stations/timeseries', options);
  return response.data;
};



// WEBPACK FOOTER //
// ./src/api/getTimeSeries.js